// Daten der Zählerliste: eine (seitenweise) Abfrage – die neueste Ablesung je Zähler kommt eingebettet mit
// (Limit 1 je Zähler), statt wie früher alle Ablesungen zu laden (1000-Zeilen-Grenze).

import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabase/client';
import { alleSeiten } from '../supabase/alleSeiten';
import { baueZeile, ZAEHLER_SELECT, type ZaehlerRoh, type ZaehlerZeile } from './liste';

export type ZaehlerListeZustand = { status: 'laedt' } | { status: 'fehler'; meldung: string } | { status: 'ok'; zeilen: ZaehlerZeile[] };

/** Gemeldet nach Änderungen (Anlegen, Bearbeiten, Löschen, Ablesung), damit die Liste neu lädt. */
export const ZAEHLER_GEAENDERT = 'immo-zaehler-geaendert';
export function meldeZaehlerGeaendert(): void {
  window.dispatchEvent(new CustomEvent(ZAEHLER_GEAENDERT));
}

export async function ladeZaehlerListe(): Promise<ZaehlerZeile[]> {
  const roh = await alleSeiten<ZaehlerRoh>((von, bis) => supabase.from('zaehler').select(ZAEHLER_SELECT)
    .order('zaehler_nummer', { ascending: true }).order('id')
    .order('datum', { ascending: false, referencedTable: 'ablesungen' }).limit(1, { referencedTable: 'ablesungen' })
    .range(von, bis) as unknown as PromiseLike<{ data: ZaehlerRoh[] | null; error: { message: string } | null }>);
  return roh.map(baueZeile);
}

export function useZaehlerListe(): { zustand: ZaehlerListeZustand; neuLaden: () => void; laedtNeu: boolean } {
  const [zustand, setZustand] = useState<ZaehlerListeZustand>({ status: 'laedt' });
  const [runde, setRunde] = useState(0);
  const [laedtNeu, setLaedtNeu] = useState(false);
  useEffect(() => {
    let aktiv = true;
    setLaedtNeu(true);
    ladeZaehlerListe()
      .then(zeilen => { if (aktiv) setZustand({ status: 'ok', zeilen }); })
      .catch((e: unknown) => { if (aktiv) setZustand({ status: 'fehler', meldung: e instanceof Error ? e.message : 'Unbekannter Fehler' }); })
      .finally(() => { if (aktiv) setLaedtNeu(false); });
    return () => { aktiv = false; };
  }, [runde]);
  useEffect(() => {
    const hoeren = () => setRunde(r => r + 1);
    window.addEventListener(ZAEHLER_GEAENDERT, hoeren);
    return () => window.removeEventListener(ZAEHLER_GEAENDERT, hoeren);
  }, []);
  const neuLaden = useCallback(() => setRunde(r => r + 1), []);
  return { zustand, neuLaden, laedtNeu };
}
